import { IUpdateStep } from '../types';

export enum ProgressStatus {
  RUNNING = 'r',
  FAILED = 'f',
  SUCCESS = 's',
  SKIPPED = 's',
  QUEUED = 'q',
}

export interface IProgress {
  id: string;
  total?: number;
  current?: number;
  lastMessage?: string;
  startedOn?: Date;
  updatedOn?: Date;
  finishedOn?: Date;
  currentRate?: number;
  status: ProgressStatus;
  error?: any;
}

export type UpdateStepsResponse = IUpdateStep[];

export enum UpdateStatus {
  ERROR,
  UPDATING,
  INITIAL,
  SUCCESS,
}
